var _rect, _path, _rect2, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 12.5,
    height: 14.5,
    stroke: "url(#paint0_linear_446_13371)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59962 7H8.40018M6.91228 3.05754C6.92092 3.04012 6.9336 3.02558 6.94901 3.01546C6.96442 3.00534 6.982 3 6.9999 3C7.0178 3 7.03538 3.00534 7.05079 3.01546C7.0662 3.02558 7.07888 3.04012 7.08752 3.05754L7.67804 4.30337C7.69212 4.33222 7.71177 4.35724 7.73559 4.37665C7.75941 4.39606 7.78679 4.40936 7.81578 4.41561C7.84477 4.42186 7.87465 4.42089 7.90327 4.41279C7.93189 4.40468 7.95853 4.38964 7.9813 4.36873L8.83687 3.55419C8.85329 3.53934 8.87353 3.53067 8.89467 3.52942C8.91581 3.52817 8.93676 3.53441 8.95451 3.54724C8.97226 3.56007 8.98589 3.57882 8.99343 3.6008C9.00098 3.62278 9.00205 3.64686 8.9965 3.66956L8.42959 5.94736C8.41801 5.99397 8.39308 6.03512 8.35857 6.06456C8.32406 6.09401 8.28186 6.11015 8.23835 6.11054H5.76165C5.71811 6.1102 5.67586 6.09408 5.64131 6.06463C5.60676 6.03518 5.58179 5.99401 5.57021 5.94736L5.0035 3.66979C4.99795 3.64708 4.99902 3.62301 5.00657 3.60102C5.01411 3.57904 5.02774 3.56029 5.04549 3.54746C5.06324 3.53463 5.08419 3.52839 5.10533 3.52964C5.12647 3.53089 5.14671 3.53956 5.16313 3.55441L6.0185 4.36895C6.04127 4.38986 6.06791 4.40491 6.09653 4.41301C6.12515 4.42112 6.15502 4.42208 6.18402 4.41583C6.21301 4.40958 6.24039 4.39628 6.26421 4.37687C6.28803 4.35747 6.30768 4.33244 6.32176 4.30359L6.91228 3.05754Z",
    stroke: "url(#paint1_linear_446_13371)",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "url(#paint2_linear_446_13371)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "url(#paint3_linear_446_13371)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_446_13371",
    x1: 0,
    y1: 8,
    x2: 14,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_446_13371",
    x1: 5,
    y1: 5,
    x2: 9,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_446_13371",
    x1: 3,
    y1: 10.5,
    x2: 11,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_446_13371",
    x1: 3,
    y1: 12.5,
    x2: 11,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.7c15922c7021d478113b7710a3c1caeb.svg";
export { ForwardRef as ReactComponent };